import { ButtonText } from '../../Button/ButtonText';
import { InnerMargin } from '../../Layout/InnerLayout/InnerMargin';

import type { TextAndLink } from '../../../types/TextAndLink';
import type { FC } from 'react';

export type ErrorPageProps = {
  errorMessage: string;
  retryLinks: TextAndLink;
};

export const ErrorReturnContents: FC<ErrorPageProps> = ({
  errorMessage,
  retryLinks,
}) => (
  <InnerMargin align="default">
    <div>{errorMessage}</div>
    <div>
      お手数ですが
      <ButtonText color="default" link={retryLinks.url}>
        {retryLinks.text}
      </ButtonText>
      からやり直して下さい。
    </div>
  </InnerMargin>
);
